import {styled} from '@mui/material';

const StyledSaludiaIcon = styled('span')<{$compact?: boolean}>`
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	width: ${({$compact}) => ($compact ? '40px' : '47px')};
	height: ${({$compact}) => ($compact ? '40px' : '47px')};
	border-radius: 50%;
	background-color: #f5f8ff;

	img {
		width: 20px;
		height: auto;
	}
`;

export {StyledSaludiaIcon};
